<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container>
    <h1 *ngIf="newUser">{{ 'T4.Settings.ManageCategories.lblCreateUser' | translate : 'Create user' }}</h1>
    <h1 *ngIf="!newUser">{{ 'T4.Settings.ManageCategories.lblEditUser' | translate : 'Edit user' }}</h1>
    <mat-tab-group dynamicHeight="true">
      <mat-tab label="{{ 'Turbo.Settings.RightsManagement.GeneralSettings' | translate : 'General settings' }}">
        <div class="users">
          <EditUserComponent [user]="user" [newUser]="newUser" (newUserCreated)="newUserCreated($event)"></EditUserComponent>
        </div>
      </mat-tab>
      <mat-tab label="{{ 'Turbo.Settings.RightsManagement.Rights' | translate : 'Rights' }}" *ngIf="!newUser && Settings.isInAny(['BackOffice', 'Admin'], true)">
        <RightsManagementComponent *ngIf="!newUser && user" [user]="user"></RightsManagementComponent>
      </mat-tab>
    </mat-tab-group>
    </t4-container>
</mat-dialog-content>
<mat-dialog-actions *ngIf="false">
</mat-dialog-actions>
<mat-progress-bar mode="indeterminate" style="margin-left: -24px; margin-bottom: -24px; width: calc(100% + 48px); margin-top: 24px;" *ngIf="false"></mat-progress-bar>
